<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="剧本名称" prop="scriptId">
                <a-select
                  show-search
                  placeholder="请选择剧本"
                  v-model="queryParam.scriptId"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  allow-clear
                >
                  <a-select-option v-for="(item) in this.playedScriptList" :value="item.scriptId" :key="item.scriptId">
                    {{ item.scriptName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="主持DM" prop="dmName">
                <a-input v-model="queryParam.dmName" placeholder="请输入主持DM" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="房间名称" prop="name">-->
<!--                <a-input v-model="queryParam.name" placeholder="请输入房间名称" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="秘钥名" prop="keyName">-->
<!--                <a-input v-model="queryParam.keyName" placeholder="请输入秘钥名" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="访问密钥" prop="keyValue">
                <a-input v-model="queryParam.keyValue" placeholder="请输入访问秘钥" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="最大人数" prop="maxPlayers">-->
<!--                <a-input v-model="queryParam.maxPlayers" placeholder="请输入最大人数" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="当前人数" prop="currentPlayers">-->
<!--                <a-input v-model="queryParam.currentPlayers" placeholder="请输入当前人数" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="是否模拟开本" prop="isSimulatePlay">
                <a-select v-model="queryParam.isSimulatePlay" placeholder="请选择是否模拟开本" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态" prop="keyValue">
                <a-select style="width: 100%" v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <!-- 目前只用到了等待中当正在游戏，以后可能需要区分2.游戏中 -->
                  <!--<a-select-option :value="1">等待中</a-select-option>-->
                  <a-select-option :value="1">游戏中</a-select-option>
                  <a-select-option :value="3">已结束</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['played:game/room:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['played:game/room:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:game/room:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['played:game/room:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :class="list.length === 0 ? 'emptyTable' : ''"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="expireTime" slot-scope="text, record">
          {{ parseTime(record.expireTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="goStep(record, 1)" v-hasPermi="['played:game/room:edit']" v-if="!record.isSimulatePlay && record.status !== 3">
            <a-icon type="logout" /> 跳转下一幕
          </a>
          <a-divider type="vertical" v-hasPermi="['played:game/room:edit']" v-if="!record.isSimulatePlay && record.status !== 3" />
          <a @click="goStep(record, 2)" v-hasPermi="['played:game/room:edit']" v-if="!record.isSimulatePlay && record.status !== 3">
            <a-icon type="rollback" /> 回退上一幕
          </a>
          <a-divider type="vertical" v-hasPermi="['played:game/room:edit']" v-if="record.status !== 3" />
          <a @click="closeRoomModalPre(record)" v-hasPermi="['played:game/room:edit']" v-if="record.status !== 3">
            <a-icon type="close-circle" /> 关闭房间
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['played:game/room:edit']" />-->
<!--          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['played:game/room:edit']">-->
<!--            <a-icon type="edit" />修改-->
<!--          </a>-->
<!--          <a-divider type="vertical" v-hasPermi="['played:game/room:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['played:game/room:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <a-modal
      ref="closeRoomRef"
      title="请输入秘钥用以关闭房间"
      :width="500"
      :visible="closeRoomModal"
      @ok="btnCloseRoom"
      @cancel="closeModal"
    >
      <a-form-model-item label="访问密钥">
        <a-input
          v-model="repeatKeyValue"
          style="width: 100%"
          placeholder="请输入访问密钥"
        />
      </a-form-model-item>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageGameRoom, delGameRoom, goStep, backgroundCloseRoom } from '@/api/played/gameRoom'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listScript } from '@/api/played/script'

export default {
  name: 'GameRoom',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      playedScriptList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        scriptId: undefined,
        dmId: null,
        dmName: null,
        name: null,
        keyName: null,
        keyValue: null,
        maxPlayers: null,
        currentPlayers: null,
        settings: null,
        isSimulatePlay: 0,
        status: undefined,
        shopName: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 60,
          ellipsis: true,
          align: 'center',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        // {
        //   title: '房间id',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '店铺名',
          width: 150,
          dataIndex: 'shopName',
          align: 'center',
          fixed: 'left'
        },
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          ellipsis: true,
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '主持DM',
          dataIndex: 'dmName',
          ellipsis: true,
          width: 130,
          align: 'center',
          fixed: 'left'
        },
        // {
        //   title: '房间名称',
        //   dataIndex: 'name',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '秘钥名',
        //   dataIndex: 'keyName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '秘钥数字',
          dataIndex: 'keyValue',
          ellipsis: true,
          width: 90,
          align: 'center'
        },
        // {
        //   title: '最大人数',
        //   dataIndex: 'maxPlayers',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '当前人数',
          dataIndex: 'currentPlayers',
          ellipsis: true,
          width: 90,
          align: 'center',
          customRender: (text) => {
            return [text - 1]
          }
        },
        {
          title: '当前章节',
          dataIndex: 'currentChapterStr',
          ellipsis: true,
          width: 140,
          align: 'center'
        },
        // {
        //   title: '房间配置',
        //   dataIndex: 'settings',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '是否模拟开本',
          dataIndex: 'isSimulatePlay',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text) => {
            return { false: '否', true: '是' }[text]
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          width: 80,
          align: 'center',
          customRender: (text) => {
            return { 1: '游戏中', 2: '游戏中', 3: '已结束' }[text]
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 140,
          align: 'center'
        },
        {
          title: '过期时间',
          dataIndex: 'expireTime',
          scopedSlots: { customRender: 'expireTime' },
          ellipsis: true,
          width: 140,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 220,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ],
      closeRoomModal: false,
      closeRoomId: null,
      repeatKeyValue: null
    }
  },
  filters: {
  },
  created () {
    this.getList()
    listScript({ scriptName: this.queryParam.scriptName }).then(res => {
      this.playedScriptList = res.data
    })
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询银河打本游戏房间列表 */
    getList () {
      this.loading = true
      pageGameRoom(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        scriptId: undefined,
        dmId: undefined,
        dmName: null,
        name: undefined,
        keyName: undefined,
        keyValue: undefined,
        maxPlayers: undefined,
        currentPlayers: undefined,
        settings: undefined,
        isSimulatePlay: 0,
        status: undefined,
        shopName: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delGameRoom(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/game/room/export', {
            ...that.queryParam
          }, `game/room_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    goStep(item, type) {
      if (item.status === 3 || this.isBeforeNow(item.expireTime)) {
        this.$message.warning('已结束的房间不能回滚!')
        return
      }
      const that = this
      const str = type === 1 ? '跳转' : '回退'
      this.$confirm({
        title: '是否确认' + str + '?',
        content: '此操作为敏感操作，确认' + str + '到房间' + (type === 1 ? '下' : '上') + '一幕？',
        onOk() {
          goStep(item.id, type).then(res => {
            if (res.success) {
              that.$message.success(str + '成功')
              that.getList()
            }
          })
        },
        onCancel() {}
      })
    },
    isBeforeNow(dateStr) {
      // 将 '2026-03-13 17:10:26' 转为本地时间的 Date 对象
      const [date, time] = dateStr.split(' ')
      const [y, M, d] = date.split('-')
      const [h, m, s] = time.split(':')
      return new Date(y, M - 1, d, h, m, s) < new Date()
    },
    closeRoomModalPre (item) {
      this.closeRoomModal = true
      this.closeRoomId = item.id
    },
    btnCloseRoom () {
      if (!this.repeatKeyValue) {
        this.$message.warning('请输入正确秘钥关闭！')
      } else {
        const data = {
          roomId: this.closeRoomId,
          keyValue: this.repeatKeyValue
        }
        backgroundCloseRoom(data).then(res => {
          this.$message.success(
            '房间已关闭！',
            3
          )
          this.getList()
          this.closeModal()
        })
      }
    },
    // 关闭模态框
    closeModal () {
      this.closeRoomModal = false
      this.closeRoomId = null
      this.repeatKeyValue = null
    }
  }
}
</script>
